import {ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';
import {IStringAnyMap} from "lib-boox";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'hero-comment',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
  ],
  templateUrl: './hero-comment.component.html',
  styleUrl: './hero-comment.component.scss'
})
export class HeroCommentComponent {
  @Input() public sectionTitle: string = '';
  @Input() public topicTitle: string = '';
  @Input() public topicDescription: string = '';

  @Input() public comment : string | null = '';
  @Input() public otherComments : IStringAnyMap[] = [];

  @Input() readOnly : boolean = false;
  @Output() close = new EventEmitter();
  @Output() save = new EventEmitter<string | null>();



  constructor(
    private cdr: ChangeDetectorRef, // For manual change detection
  ) { }

  // ngAfterViewInit(): void {
  //   if(this.topic?.topic_comment){
  //     this.comment = this.topic.topic_comment;
  //     this.cdr.detectChanges(); // Trigger change detection
  //   }
  // }

  onClose(){
    this.close.emit();
  }

  onSave() {
    this.save.emit(this.comment);
    this.onClose();
  }
}
